export default {
  data() {
    return {
      reservationSiteConst: [
        {label: 'Airbnb', value: 'AIRBNB'},
        {label: 'Booking', value: 'BOOKING'},
        {label: 'Abritel', value: 'VRBO'},
        {label: 'Guestadom', value: 'VGA'},
        {label: 'PAP', value: 'PAP'},
        {label: 'Holidu', value: 'HOLIDU'},
        /*{label: 'Maeva', value: 'MAEVA'},*/
        {label: 'Hometogo', value: 'HOMETOGO'},
        {label: 'Your Ideal Office', value: 'YOURIDEALOFFICE'},
        {label: 'Sans plateforme', value: 'NULL'},
        {label: this.$t('undefined'), value: undefined},
      ],
    };
  },
  computed: {
    reservationSiteOnboardingConst() {
      return [
        {label: 'Guestadom', value: 'VGA', icon: 'logo-site guestadom', disabled: true},
        {label: 'Airbnb', value: 'AIRBNB', icon: 'logo-site airbnb', third: this.isOffrePremium ? null : 'Recommandée'},
        {
          label: 'Booking',
          value: 'BOOKING',
          icon: 'logo-site booking',
          third: this.isOffrePremium ? null : 'Recommandée',
        },
        {label: 'Abritel', value: 'VRBO', icon: 'logo-site vrbo', third: this.isOffrePremium ? null : 'Recommandée'},
        {label: 'PAP', value: 'PAP', icon: 'logo-site pap'},
        {label: 'Holidu', value: 'HOLIDU', icon: 'logo-site holidu'},
        /*{label: 'Maeva', value: 'MAEVA', icon: 'logo-site maeva'},*/
        {label: 'Hometogo', value: 'HOMETOGO', icon: 'logo-site hometogo'},
        {label: 'Your Ideal Office', value: 'YOURIDEALOFFICE', icon: 'logo-site youridealoffice'},
      ];
    },
    reservationSiteConstDefined() {
      return this.reservationSiteConst.filter((el) => el.value !== undefined);
    },
    reservationSiteConstDefinedReview() {
      return this.reservationSiteConst.filter((el) => el.value !== undefined);
    },
  },
  methods: {
    displayForReservationSiteConst(value) {
      let result = this.reservationSiteConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
    iconReservation(site) {
      if (!site) return 'cancel';
      let siteLower = site.toLowerCase();

      if (siteLower.includes('vrbo')) return 'vrbo';
      if (siteLower.includes('pap')) return 'pap';
      if (siteLower.includes('holidu')) return 'holidu';
      if (siteLower.includes('airbnb')) return 'airbnb';
      if (siteLower.includes('booking')) return 'booking';
      if (siteLower.includes('homeaway')) return 'homeaway';
      if (siteLower.includes('maeva')) return 'maeva';
      if (siteLower.includes('hometogo')) return 'hometogo';
      if (siteLower.includes('office')) return 'youridealoffice';

      if (siteLower.includes('guest-adom')) return 'guestadom';
      if (siteLower.includes('guestadom')) return 'guestadom';
      if (siteLower.includes('vga')) return 'guestadom';

      return 'cancel';
    },
    iconReservationFromKey(site) {
      if (!site) return 'cancel';

      if (site === 'VRBO') return 'vrbo';
      if (site === 'PAP') return 'pap';
      if (site === 'HOLIDU') return 'holidu';
      if (site === 'HOMETOGO') return 'hometogo';
      if (site === 'YOURIDEALOFFICE') return 'youridealoffice';
      if (site === 'VGA') return 'guestadom';
      if (site === 'AIRBNB') return 'airbnb';
      if (site === 'BOOKING') return 'booking';

      return 'cancel';
    },
    displayReservationSite(site) {
      if (!site) return '';
      let siteLower = site.toLowerCase();

      if (siteLower.includes('vrbo')) return 'Abritel';
      if (siteLower.includes('pap')) return 'PAP Vacances';
      if (siteLower.includes('holidu')) return 'Holidu';
      if (siteLower.includes('airbnb')) return 'Airbnb';
      if (siteLower.includes('booking')) return 'Booking.com';
      if (siteLower.includes('homeaway')) return 'Abritel';
      if (siteLower.includes('maeva')) return 'Maeva';
      if (siteLower.includes('hometogo')) return 'Hometogo';
      if (siteLower.includes('office')) return 'Your Ideal Office';
      if (siteLower.includes('guest-adom')) return 'Guestadom';
      if (siteLower.includes('guestadom')) return 'Guestadom';
      if (siteLower.includes('vga')) return 'Guestadom';
      if (siteLower.includes('marriott')) return 'Marriott';
      if (siteLower.includes('hometogo')) return 'Hometogo';
      if (siteLower.includes('plumguide')) return 'Plumguide';

      return site;
    },
    displayReviewsReservationSite(site) {
      if (!site) return '';
      let siteLower = site.toLowerCase();

      if (siteLower.includes('pap')) return 'PAP';
      if (siteLower.includes('booking')) return 'Booking';
      return this.displayReservationSite(site);
    },
    displayReservationSiteFromKey(site) {
      if (!site) return '';
      if (site === 'VGA') return 'Guestadom';
      if (site === 'VRBO') return 'Abritel';
      if (site === 'PAP') return 'PAP Vacances';
      if (site === 'HOLIDU') return 'Holidu';
      if (site === 'HOMETOGO') return 'Hometogo';
      if (site === 'YOURIDEALOFFICE') return 'Your Ideal Office';
      return site;
    },
    iconReservation2(type, site) {
      if (type === 'GUEST' || type === 'GUEST_CANCEL') return this.iconReservation(site);
      if (type === 'OWNER') return 'owner';
      return 'blockade';
    },
    isSiteVga() {
      if (!this.reservation.reservationSite) return false;
      return (
        this.reservation.reservationSite.includes('happystay') ||
        this.reservation.reservationSite.includes('guest-adom')
      );
    },

    // ATTENTION ! si les méthodes iconReservation et iconReservation2 étaient nommées de la même manière
    // javaScript serait incapable de retrouver laquelle est laquelle malgrés la différence de nombre de paramètres
  },
};
